/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetRecommendationsNearNewbuildingRequest,
  TGetRecommendationsNearNewbuildingModel,
  IMappers,
  TGetRecommendationsNearNewbuildingResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetRecommendationsNearResponse } from '../../entities/get_recommendations_near_newbuilding/GetRecommendationsNearResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetRecommendationsNearNewbuildingModel(
  parameters: IGetRecommendationsNearNewbuildingRequest,
): TGetRecommendationsNearNewbuildingModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-search',
    pathApi: '/v1/get-recommendations-near-newbuilding/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetRecommendationsNearNewbuildingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetRecommendationsNearNewbuildingRequest;
}

export async function fetchGetRecommendationsNearNewbuilding<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetRecommendationsNearNewbuildingOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetRecommendationsNearNewbuildingResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetRecommendationsNearNewbuildingModel(parameters),
    config,
  )) as FetchResponse<TGetRecommendationsNearNewbuildingResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRecommendationsNearResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetRecommendationsNearNewbuildingResponse>;
}
